module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../../assets/img/live-qa-icon.png")
    }
  }), _vm._v("Upcoming Sessions"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Your next live session countdown.'),
      expression: "'Your next live session countdown.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.meetings) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "meetings list-group"
  }, _vm._l((_vm.meetings), function(meeting) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('h6', [_vm._v("Group " + _vm._s(_vm.groupName(meeting.group)))]), _vm._v(" "), _c('span', {
      staticClass: "start-time"
    }, [_vm._v(_vm._s(_vm._f("longDate")(meeting.startTime)))]), _vm._v(" "), _c('div', [_c('countdown', {
      attrs: {
        "duration": meeting.duration,
        "date": meeting.startTime
      }
    })], 1)])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbd2daf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SupervisorSessions.vue
// module id = 1988
// module chunks = 2